import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TrnAdmissionService} from '../configuration/trn-admission/trn-admission.service';
import {TemrDoctorsAdviceService} from '../configuration/temr-doctors-advice/temr-doctors-advice.service';
import {TemrVisitSymptomService} from '../configuration/temr-visit-symptom/temr-visit-symptom.service';
import {TemrVisitAllergyService} from '../configuration/temr-visit-allergy/temr-visit-allergy.service';
import {TemrVitalService} from '../configuration/temr-vital/temr-vital.service';
import {CpoePrescriptionService} from '../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-prescription/cpoe-prescription.service';
import {TemrVisitDiagnosisService} from '../configuration/temr-visit-diagnosis/temr-visit-diagnosis.service';
import {TemrVisitNonDrugAllergyService} from '../configuration/temr-visit-non-drug-allergy/temr-visit-non-drug-allergy.service';
import {TemrTimelineService} from '../configuration/temr-timeline/temr-timeline.service';
import {TemrVisitChiefComplaintService} from '../configuration/temr-visit-chief-complaint/temr-visit-chief-complaint.service';
import {CpoeInvestigationService} from '../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-investigation/cpoe-investigation.service';
import {TemrVisitHistoryService} from '../configuration/temr-visit-history/temr-visit-history.service';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {MstVisitService} from '../configuration/mst-visit/mst-visit.service';
import {CpoeDoctorAdviceService} from '../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-doctoradvice/cpoe-doctoradvice.service';

@Component({
  selector: 'app-ipd-patient-case-paper',
  templateUrl: './ipd-patient-case-paper.component.html',
  styleUrls: []
})
export class IpdPatientCasePaperComponent implements OnInit {
  admission_id: any;
  allergyList: Array<any> = [];
  timelineList: Array<any> = [];
  vitalList: Array<any> = [];
  diagnosisList: Array<any> = [];
  prescriptionList: Array<any> = [];
  servicesList: Array<any> = [];
  clinicalProcedureList: Array<any> = [];
  chiefComplaintList: Array<any> = [];
  systomsList: Array<any> = [];
  drugAllergiesList: Array<any> = [];
  nonDrugAllergiesList: Array<any> = [];
  historyList: Array<any> = [];
  admissionDetails: any = {};
  mstUnit: any = {};
  unitid: any;
  currentVisit: any = {};
  currentPatient: any = {};
  progressBar: Boolean = false;
  savedOtRequest: Array<any> = [];
  constructor(private route: ActivatedRoute,
              private router: Router,
              private trnAdmissionService: TrnAdmissionService,
              private temrTimelineService: TemrTimelineService,
              private temrVitalService: TemrVitalService,
              private temrDiagnosisService: TemrVisitDiagnosisService,
              private cpoeInvestigationService: CpoeInvestigationService,
              private cpoePrescriptionService: CpoePrescriptionService,
              private temrDoctorsAdviceService: TemrDoctorsAdviceService,
              private temrVisitHistoryService: TemrVisitHistoryService,
              private temrVisitChiefComplaintService: TemrVisitChiefComplaintService,
              private temrVisitSymptomService: TemrVisitSymptomService,
              private temrVisitAllergyService: TemrVisitAllergyService,
              private temrVisitNonDrugAllergyService: TemrVisitNonDrugAllergyService,
              private mstUnitService: MstUnitService,
              private mstVisitService: MstVisitService,
              private cpoeDoctorAdviceService:CpoeDoctorAdviceService) {
  }

  ngOnInit() {
    this.progressBar = true;
    this.unitid = JSON.parse(sessionStorage.getItem('unitId'));
    this.route.params.subscribe(params => {
      this.admission_id = params['admission_id'];
      this.getAdmissionDetails();
    });
  }

  getAdmissionDetails() {
    this.trnAdmissionService.getRecordService(this.admission_id).then(resp => {
      this.admissionDetails = resp;
      // console.log('admission');
      // console.log(this.admissionDetails);
      this.progressBar = false;
      this.mstVisitService.getVisitByPatientIdOfIpdPatient(this.admissionDetails.admissionPatientId.patientId, 1)
        .then(resp => {
          this.currentVisit = resp;
          this.currentPatient = resp.visitPatientId;
          this.getUnitDetailsById(this.unitid);
        });
      this.getIPDCasePaper();
    });
  }

  getIPDCasePaper() {
    this.temrTimelineService.getTimelineByAdmissionIdAndDate(this.admissionDetails)
      .then(resp => {
        resp = resp;
        this.timelineList = resp;
        // console.log('timelines');
        // console.log(resp);
        //vital list
        this.temrVitalService.getAllRecordByTimelineList(this.timelineList).then(resp => {
          this.vitalList = resp;
          // console.log('vitalList');
          // console.log(this.vitalList);
        });
        //Dignosis list
        this.temrDiagnosisService.getAllRecordByTimelineList(this.timelineList).then(resp => {
          this.diagnosisList = resp;
          // console.log('diagnosisList');
          // console.log(this.diagnosisList);
        });
        //Investigation (Services) list
        this.cpoeInvestigationService.getAllRecordByTimelineList(this.timelineList).then(resp => {
          this.servicesList = resp;
          // console.log('servicesList');
          // console.log(this.servicesList);
        });
        //Prescription list
        this.cpoePrescriptionService.getAllRecordByTimelineList(this.timelineList).then(resp => {
          this.prescriptionList = resp;
          console.log('prescriptionList');
          console.log(this.prescriptionList);
        });
        //Clinical Procedure list
        this.temrDoctorsAdviceService.getAllRecordByTimelineList(this.timelineList).then(resp => {
          this.clinicalProcedureList = resp;
          // console.log('clinicalProcedureList');
          // console.log(this.clinicalProcedureList);
        });
        //History list
        this.temrVisitHistoryService.getAllRecordByTimelineList(this.timelineList).then(resp => {
          this.historyList = resp;
          // console.log('historyList');
          // console.log(this.historyList);
        });
        //chief complaint list
        this.temrVisitChiefComplaintService.getAllRecordByTimelineList(this.timelineList).then(resp => {
          this.chiefComplaintList = resp;
          // console.log('chiefComplaintList');
          // console.log(this.chiefComplaintList);
        });
        //Symtoms list
        this.temrVisitSymptomService.getAllRecordByTimelineList(this.timelineList).then(resp => {
          this.systomsList = resp;
          // console.log('systomsList');
          // console.log(this.systomsList);
        });
        //drug allergies list by patient id
        this.temrVisitAllergyService.getAllRecordByPatientId(this.admissionDetails.admissionPatientId.patientId).then(resp => {
          this.drugAllergiesList = resp;
          // console.log('drugAllergiesList');
          // console.log(this.drugAllergiesList);
        });
        //nondrug allergies list
        this.temrVisitNonDrugAllergyService.getAllRecordByTimelineList(this.timelineList).then(resp => {
          this.nonDrugAllergiesList = resp;
          // console.log('nonDrugAllergiesList');
          // console.log(this.nonDrugAllergiesList);
        });


          this.cpoeDoctorAdviceService.getRecordOtRequestByPatienteId(this.admissionDetails.admissionPatientId.patientId)
              .then(resp1 => {
                  console.log('getOtRequestList');
                  console.log(resp1);
                  this.savedOtRequest = resp1;
              });
      });
  }

  getUnitDetailsById(id: any) {
    this.mstUnitService.getRecordService(id)
      .then(resp => {
        this.mstUnit = resp;
        // console.log('unit details');
        // console.log(resp);
      });
  }

  navigateBack() {
    this.router.navigate(['patientchart/patient-chart-parent/' + 'ipd' + '/' + this.currentVisit.visitId + '/patient-timeline']);
  }

  printCasePaper(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section'


    ).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          
          <link rel="stylesheet" href="assets/css/your_style.css">
          
          <!-- Latest compiled and minified CSS -->
          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.1.0/css/bootstrap.min.css">
          
          <!-- jQuery library -->
          <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
          
          <!-- Popper JS -->
          <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.0/umd/popper.min.js"></script>
          
          <!-- Latest compiled JavaScript -->
          <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.1.0/js/bootstrap.min.js"></script>
          
          <style>
          @media print {
            body{              
                -webkit-print-color-adjust: exact; 
            }
           }
          
          .ui-grid-col-12 {
              width: 100%;
          }
          .col-xs-12{
              width: 100%;
          }
          
          .col-xs-6{
              float: left;              
              position: relative;
              min-height: 1px;
              padding-right: 15px;
              padding-left: 15px;
          }
            
          h5 {
            font-size: 17px;
            font-weight: 300;
            line-height: normal;
          } 
          
          .bordered {
              border: 1px solid rgba(0, 0, 0, .2);
          }
          
          .caseReport .ui-panel-titlebar{
              padding: 0px 0px 0px 10px;
            }
            
            .caseReport h5{
              margin: 5px 0;
            }
            
            .caseReport .ui-widget-header{
              background: #337ab7;
              color: #fff;
              border-color: #337ab7;
            }
            
            .caseReportPrimary .ui-widget-content{
              border: 1px solid #337ab7;
              border-left: 5px solid #337ab7;
            }
            
            .caseReportInfo .ui-widget-content{
              border: 1px solid #17a2b8;
              border-left: 5px solid #17a2b8;
            }
            
            .caseReportWarning .ui-widget-content{
              border: 1px solid #ffc107;
              border-left: 5px solid #ffc107;
            }
            
            .caseReportDanger .ui-widget-content{
              border: 1px solid #dc3545;
              border-left: 5px solid #dc3545;
            }
            
            .caseReportSuccess .ui-widget-content{
              border: 1px solid #28a745;
              border-left: 5px solid #28a745;
            }
            </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

    // getOtRequestList()
    // {
    //     this.savedOtRequest= [];
    //     this.cpoeDoctorAdviceService.getRecordOtRequestByPatienteId(this.admissionDetails.admissionPatientId.patientId)
    //         .then(resp => {
    //             console.log('getOtRequestList');
    //             console.log(resp);
    //             this.savedOtRequest = resp.content;
    //         });
    // }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd-patient-case-paper/ipd-patient-case-paper.component.ts